// src/components/ui/TableDataNoAvailable.jsx
import Lottie from "lottie-react";
import Loader from "../../assets/lottie/no_data_found.json";

const TableDataNoAvailable = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div style={{ width: "400px" }}>
        <Lottie animationData={Loader} loop={true} />
      </div>
    </div>
  );
};

export default TableDataNoAvailable;
